export default {
    namespaced: true,
    state: {
        ws: null,
        chatHistory: {
            "sessionid": "",
            "conversation_name": "",
            "conversation_id": "",
            "gpt-4o": [],
            "moonshot-v1-auto": []
        },
    },
    mutations: {
        setWs(state, target) {
            state.ws = target;
        },
        addChatHistory(state, {modelName, role, content}) {
            // 检查对话模型是否存在
            if (state.chatHistory[modelName]) {
                // 添加消息到指定的对话模型
                state.chatHistory[modelName].push({role, content});
            } else {
                // 如果模型不存在，可以在这里处理错误或添加新的模型
                this.$message.error(`模型 '${modelName}' 不存在.`);
            }
        },
    },
    actions: {},
    getters: {
        ws: state => state.ws
    }
};